import React from 'react';
import { PixelStreamComponent } from '@convai/experience-embed';
import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

const DemoPage: React.FC = () => {
  // Replace with your actual Convai Experience ID
  const expId = '0653fa10-4206-40c9-ad1c-f9d8a0aa0920';

  return (
    <div className="min-h-screen bg-[#0a0a0a] flex flex-col">
      {/* Header */}
      <header className="w-full px-6 py-4 bg-gray-900/80 backdrop-blur border-b border-gray-800">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
            <span className="font-medium">Back to Home</span>
          </Link>
          <h1 className="text-2xl font-bold text-white">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-700">
              DIVA
            </span>{' '}
            Demo
          </h1>
          <div className="w-24"></div> {/* Spacer for centering */}
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 relative">
        {/* Embed Container - Full Width */}
        <div className="absolute inset-0">
          <PixelStreamComponent
            expId={expId}
            onReady={() => {
              console.log('Pixel stream is ready');
            }}
            onError={(error) => {
              console.error('Pixel stream error:', error);
            }}
          />
        </div>
      </main>
    </div>
  );
};

export default DemoPage;
